import React from 'react';
import { Twitter, Instagram, Facebook, Linkedin, Youtube, Send } from 'lucide-react';

const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/bethcoin',
  instagram: 'https://instagram.com/bethcoin',
  facebook: 'https://www.facebook.com/profile.php?id=61595991513638',
  linkedin: 'https://linkedin.com/company/bethcoin',
  youtube: 'https://youtube.com/@bethcoin',
  telegram: 'https://t.me/bethcoin'
};

export const FollowUsButton = ({ className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="text-slate-400 text-sm font-medium">Follow Us:</span>
    <div className="flex gap-2">
      <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noopener noreferrer" 
        aria-label="Follow us on Twitter"
        title="Twitter"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-800 hover:bg-blue-500 text-slate-400 hover:text-white transition-colors"
        data-testid="follow-twitter">
        <Twitter className="w-4 h-4" />
      </a>
      <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer"
        aria-label="Follow us on Instagram"
        title="Instagram"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-800 hover:bg-pink-500 text-slate-400 hover:text-white transition-colors"
        data-testid="follow-instagram">
        <Instagram className="w-4 h-4" />
      </a>
      <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer"
        aria-label="Follow us on Facebook"
        title="Facebook"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-800 hover:bg-blue-600 text-slate-400 hover:text-white transition-colors"
        data-testid="follow-facebook">
        <Facebook className="w-4 h-4" />
      </a>
      <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noopener noreferrer"
        aria-label="Follow us on LinkedIn"
        title="LinkedIn"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-800 hover:bg-blue-700 text-slate-400 hover:text-white transition-colors"
        data-testid="follow-linkedin">
        <Linkedin className="w-4 h-4" />
      </a>
      <a href={SOCIAL_LINKS.telegram} target="_blank" rel="noopener noreferrer"
        aria-label="Join us on Telegram"
        title="Telegram"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-800 hover:bg-cyan-500 text-slate-400 hover:text-white transition-colors"
        data-testid="follow-telegram">
        <Send className="w-4 h-4" />
      </a>
    </div>
  </div>
);

export const FollowUsBar = ({ className = '' }) => (
  <div className={`flex flex-wrap items-center justify-center gap-4 py-4 ${className}`} data-testid="follow-us-bar">
    <span className="text-white font-semibold">Follow BETHCOIN</span>
    <div className="flex gap-3">
      <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noopener noreferrer" 
        className="px-4 py-2 bg-slate-800 hover:bg-blue-500 text-slate-300 hover:text-white rounded-lg flex items-center gap-2 transition-colors text-sm">
        <Twitter className="w-4 h-4" /> Twitter
      </a>
      <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer"
        className="px-4 py-2 bg-slate-800 hover:bg-pink-500 text-slate-300 hover:text-white rounded-lg flex items-center gap-2 transition-colors text-sm">
        <Instagram className="w-4 h-4" /> Instagram
      </a>
      <a href={SOCIAL_LINKS.telegram} target="_blank" rel="noopener noreferrer"
        className="px-4 py-2 bg-slate-800 hover:bg-cyan-500 text-slate-300 hover:text-white rounded-lg flex items-center gap-2 transition-colors text-sm">
        <Send className="w-4 h-4" /> Telegram
      </a>
      <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer"
        className="px-4 py-2 bg-slate-800 hover:bg-red-500 text-slate-300 hover:text-white rounded-lg flex items-center gap-2 transition-colors text-sm">
        <Youtube className="w-4 h-4" /> YouTube
      </a>
    </div>
  </div>
);

export default FollowUsButton;
